import { useState ,useEffect, useMemo} from 'react'
import {useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getUsers, getDms, addimei } from '../../redux/actions';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import ImeiSummary from '../ImeiSummary/ImeiSummary';
import Modal from '../UI/Modal/Modal';
import Button from '../UI/Button/Button';
import { LoaderList } from '../UI/Loader/Loader';
import  CheckboxCustom  from '../UI/CheckboxCustom/CheckboxCustom';
import magnifier from "../../img/magnifier.svg"
import plus from "../../img/plus.png"
import './ImeiList.css';
import { jwtDecode } from 'jwt-decode'; // Добавьте эту библиотеку для декодирования JWT

export default function ImeiList() {
    const navigate = useNavigate();
    const token = localStorage.getItem('token'); // Предположим, что токен хранится в localStorage
    const [input,setInput] =useState('');
    const dispatch = useDispatch();
    const [isLoading,setIsLoading]=useState(false);
    const role=useSelector((state) => state.userdata?.role);
    const length=useSelector((state) => state.dm?.data?.length);
    const users=useSelector((state) => state.usersdata?.users);

    // Функция для проверки срока действия токена
    const isTokenExpired = (token) => {
        try {
            const decoded = jwtDecode(token);
            return decoded.exp < Date.now() / 1000;
        } catch (e) {
            return true; // Если токен невалидный, считаем его просроченным
        }
    };

    useEffect(() => {
        // Проверяем токен при каждом рендере
        if (!token || isTokenExpired(token)) {
            localStorage.removeItem('token');
            navigate('/');
            return;
        }

        setIsLoading(true);
        const fetchGetDms = async () => {
            try {
                await dispatch(getDms());
                setIsLoading(false);
            } catch (error) {
                console.error('Ошибка при получении данных:', error);
                // Если ошибка связана с авторизацией, перенаправляем на страницу входа
                if (error.response && error.response.status === 401) {
                    localStorage.removeItem('token');
                    navigate('/');
                }
            }
        };
        fetchGetDms();
    }, [length, token, navigate, dispatch]);

    useEffect(() => {
        const fetchGetUsers = async () => {
            try {await dispatch(getUsers());  
            } catch (error) { console.error('Ошибка при получении данных:', error);}
        };
            fetchGetUsers();
    }, [dispatch]);

    useEffect(() => {
        if (!token) {navigate('/');}
        if (role === 1) {
            } else if (role) {
            navigate('/');
            }
    }, [role]);

    const data = useSelector((state) => state.dm?.data);
    const [modal, setModal] = useState(false);
    const [inputvalue, setInputvalue] = useState(1);
    const [hasError, setHasError] = useState(false);
    const [lengthError, setLengthError] = useState(false);
    const [checkedDM, setCheckedDM] = useState(false);
    const [checkedPumps, setCheckedPumps] = useState(false);
    const browserTime = new Date();

    function handleCheckedDM(e) { 
        setCheckedDM(e.target.checked);
        setCheckedPumps(false);
    }

    function handleCheckedPumps(e) { 
        setCheckedPumps(e.target.checked);
        setCheckedDM(false);
    }

    function onClickWinOpen() {
        setInputvalue('');
        setModal(true);
        setHasError(false);
        setLengthError(false)
    }
    async function onClickSave (inputvalue) {
        if (!inputvalue) {
            setHasError(true);
            return;
        }
      setHasError(false);

      if (inputvalue.length!==15) {
        setLengthError(true);
        return;
        } 
        const num= checkedDM ? 6 : (checkedPumps ? 3 : null);
       setInputvalue(''); 
       setModal(false);
       setLengthError(false)
       setCheckedDM(false);
       setCheckedPumps(false);
      try { await dispatch(addimei(inputvalue, num));  //Добавляе новый imei
            await dispatch(getDms()); // Получаем данные только после успешного добавления imei
      } catch (error) {console.error('Ошибка при выполнении операции:', error)}
    }

    const filteredImeis = useMemo(() => {
        if (!data) return [];

        const searchTerm = input.toLowerCase().trim()
        if (!searchTerm) return data;

        return data.filter(item => {
          return (item.imei_name || '').toLowerCase().includes(searchTerm) ||
                 (item.username || '').toLowerCase().includes(searchTerm);
        });
      }, [data, input]); 

    return(
    <> 
        <div className='main-ImeiList'> 
            <div className='ImeiListHeader'> 
                <div className='ImeiListName'> 
                    <h3> Всего IMEI<span>{data.length}</span></h3> 
                    <div className='ImeiListAdd'>
                        <button className="ImeilistBtn" onClick={()=>onClickWinOpen()} > 
                            <img src={plus} alt="Result" className='ImeiListQuestImgAdd' />
                        Создать IMEI</button>
                    </div>
                </div>
                <div className='ImeiListQuest'> 
                    <input type='text' className='ImeiListInput' placeholder='Введите название или логин пользователя'
                        value={input}
                        onChange={(e)=>setInput(e.target.value)}
                    /> 
                    {input==='' ? (
                  <img src={magnifier} alt="Result" className='ImeiListQuestImgMag'/>
                  ) : (
                    <svg  onClick={()=>setInput('')} className='ImeiListQuestDelet' height="30" viewBox="0 0 200 200" width="30">    
                    <path d="M114,100l49-49a9.9,9.9,0,0,0-14-14L100,86,51,37A9.9,9.9,0,0,0,37,51l49,49L37,149a9.9,9.9,0,0,0,14,14l49-49,49,49a9.9,9.9,0,0,0,14-14Z" />
                </svg>
                  )}
                </div>
            </div> 
                {isLoading ? (<LoaderList />) : (
                 <div className='ImeiListMainContent'>
                    <TransitionGroup>
                    {filteredImeis.map(item=>
                                <CSSTransition
                                    key={item.imei}
                                    timeout={500}
                                    classNames='imeiCard'
                                >
                                    <ImeiSummary item={item} key={item.id}
                                     users={users} browserTime={browserTime}/>
                                </CSSTransition>   
                                )}
                    </TransitionGroup>
                 </div> 
                )}
        </div>
        <Modal open={modal}>     
                    <div className='modalHeader'>
                        <h3>Введите IMEI и выберите тип</h3>
                        <svg  onClick={()=>setModal(false)} height="30" viewBox="0 0 200 200" width="30">    
                            <path d="M114,100l49-49a9.9,9.9,0,0,0-14-14L100,86,51,37A9.9,9.9,0,0,0,37,51l49,49L37,149a9.9,9.9,0,0,0,14,14l49-49,49,49a9.9,9.9,0,0,0,14-14Z" />
                        </svg> 
                    </div>
                    <div className='modalSwitch'> 
                        <CheckboxCustom label="ДМ" size="large" color="#4caf50"
                        checked={checkedDM}
                        onChange={handleCheckedDM} />
                        <CheckboxCustom label="Насосная" size="large" color="#4caf50"
                        checked={checkedPumps}
                        onChange={handleCheckedPumps} />
                    </div> 
                    <div className='modalInfo'> 
                        <label className='labelInfo'></label>
                        <h4 className='labelInfoQuet'>
                        {hasError ? ("Передумали?") : (
                            lengthError ? ("Вы ввели неверный IMEI, проверьте еще раз!") : (
                            "Желаете добавить новый IMEI "+`${inputvalue}`+'?'))}</h4>
                    </div>
                        <div className='contentControl'>
                        <input type='number' className='input' value={inputvalue} 
                        onChange={e=>{
                            const value = e.target.value.slice(0, 15); // Ограничиваем длину
                            setInputvalue(value);
                            if (lengthError) setLengthError(false);
                            }}
                        placeholder='Введите IMEI'
                        style={{border: hasError || lengthError ? ('1px solid red') : (inputvalue.length===15 ? ('5px solid LawnGreen') : (null))}} />
                            <div className='modalButton' >
                                <Button onClick={() => setModal(false)}>Отмена</Button>
                                <Button onClick={()=>onClickSave(inputvalue)}>Сохранить</Button>
                            </div>
                        </div>       
        </Modal>  
    </>
    )
}